import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { transportType } from "../../../shared/transport-type/transport-type.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { Chip } from "primeng/chip";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-transport-type-select",
  templateUrl: "./transport-type-select.component.html",
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, Chip, FormsModule],
})
export class TransportTypeSelectComponent implements OnInit {
  public readonly transportTypeChange = output<string | null>();
  @Input() public transportType: string | null = null;
  @Input() public placeholder = "Select transport type";
  public readonly disabled = input(false);
  public readonly showClear = input(false);

  public subscription = new Subscription();
  public transportTypeList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildTransportTypeList();
  }

  public onTransportTypeChange(event: { value: string }) {
    this.transportType = event.value;
    this.transportTypeChange.emit(event.value);
  }

  public clearTransportType() {
    this.transportType = null;
    this.transportTypeChange.emit(null);
  }

  public getTransportTypeLabel(value: string): string {
    return (
      this.transportTypeList.find((item) => item.value === value)?.label ?? ""
    );
  }

  private buildTransportTypeList() {
    (Object.keys(transportType) as (keyof typeof transportType)[]).map(
      (key) => {
        this.transportTypeList.push({
          label: transportType[key],
          value: key,
        });
      },
    );
  }
}
